import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SupplierInvoiceReducer } from '../reducers';

export const supplierInvoiceFeature = createFeatureSelector<SupplierInvoiceReducer.DataState>(SupplierInvoiceReducer.featureName);

export const selectSupplierInvoice = createSelector(supplierInvoiceFeature, (state: SupplierInvoiceReducer.DataState) => state.item);
